/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import { Text } from "@bookingcom/bui-react";
import React from "react";
import { useTheme } from "@bookingcom/bui-react";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../../store";
import { UIOrderStatus } from "@flights/types";
import Frame from "components/elements/Frame";

const ORDER_STATUS: { [P in UIOrderStatus]: String } = {
  PRE_ORDER: "Unknown",
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  CANCELLED: "Cancelled",
  ERROR: "Failed",
  DRAFT: "Draft"
};

function setType(type: UIOrderStatus) {
  const params = new URLSearchParams(location.search);
  params.set("type", type);
  location.search = params.toString();
}

function setAddOnType(type: UIOrderStatus) {
  const params = new URLSearchParams(location.search);
  params.set("addOnType", type);
  location.search = params.toString();
}

const ConfirmationTestingTools: React.FunctionComponent = () => {
  const theme = useTheme();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { order, addOnOrder } = store.order;

  if (!order || !order.isTest) {
    return null;
  }

  return (
    <Frame pt={4} pb={4}>
      <Frame p={4} attributes={{ style: { backgroundColor: theme.colors.color_destructive_background_alt } }}>
        <Frame>
          <Text tagName="span" variant="body_2">
            Confirmation type:
          </Text>
          <select
            value={order.orderStatus}
            onChange={(evt) => {
              setType(evt.target.value as UIOrderStatus);
            }}
          >
            {Object.keys(ORDER_STATUS).map((type, i) => {
              return (
                <option key={i} value={type}>
                  {/* @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely. */}
                  {ORDER_STATUS[type]}
                </option>
              );
            })}
          </select>
        </Frame>
        {addOnOrder?.isTest && (
          <Frame>
            <Text tagName="span" variant="body_2">
              Add-on type:{" "}
            </Text>
            <select
              value={addOnOrder.orderStatus}
              onChange={(evt) => {
                setAddOnType(evt.target.value as UIOrderStatus);
              }}
            >
              {Object.keys(ORDER_STATUS).map((type, i) => {
                return (
                  <option key={i} value={type}>
                    {/* @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely. */}
                    {ORDER_STATUS[type]}
                  </option>
                );
              })}
            </select>
          </Frame>
        )}
      </Frame>
    </Frame>
  );
};

export default ConfirmationTestingTools;
